import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Link, Route, Switch } from 'react-router-dom';
import './index.css';
import Home from './Home';
import About from './About';
import Services from './services';
import Header from './components/header';
import Footer from './components/footer';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <div>
    <div>
      <Header />
    </div>
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Home}/>
        <Route path="/about" component={About}/>
        <Route path="/services" component={Services}/>
      </Switch>
    </BrowserRouter>

    <div>
      <Footer />
    </div>
  </div>
,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js